const ALLOWED_ACCENT_COLORS = ['blue'];

export const isAllowedTrainingAccentColor = accentColor => ALLOWED_ACCENT_COLORS.includes(accentColor);
export const defaultAllowedTrainingAccentColor = () => ALLOWED_ACCENT_COLORS[0];
